if($('.homepage').length) {
    $('#fullpage').fullpage({
        navigation: true,
        navigationPosition: 'right',
        recordHistory: false,
        animateAnchor: false,
        continuousVertical: false,
        //navigationTooltips: ['Progetti', 'I.W.C.C.', 'Atelier', 'Su Misura', 'Immaginario', 'Colori d\'Autore'],
        scrollingSpeed: 1000,
        easingcss3: 'cubic-bezier(1,.01,.39,1)',

        afterLoad: function(anchorLink, index) {
            $('.slide-info-holder .box').delay(150).eq(index - 1).fadeIn();
        },

        onLeave: function(anchorLink, index) {
            $('.slide-info-holder .box').fadeOut(250);
        }
    });

    $('.slide-arrow-up').click(function() {
        $.fn.fullpage.moveSectionUp();
    });

    $('.slide-arrow-down').click(function() {
        $.fn.fullpage.moveSectionDown();
    });
}